import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import UltimateGuide from "@/pages/article/sugargoo-spreadsheet-ultimate-guide/page";
import ShoesGuide from "@/pages/article/sugargoo-spreadsheet-shoes-guide/page";
import ClothingGuide from "@/pages/article/sugargoo-spreadsheet-clothing-guide/page";
import BestFinds from "@/pages/article/sugargoo-spreadsheet-best-finds/page";
import BeginnerTutorial from "@/pages/article/sugargoo-spreadsheet-beginner-tutorial/page";
import Review2026 from "@/pages/article/sugargoo-review-2026/page";
import ShippingCost from "@/pages/article/sugargoo-shipping-cost-guide/page";
import CouponGuide from "@/pages/article/sugargoo-coupon-discount-guide/page";
import WarehouseGuide from "@/pages/article/sugargoo-warehouse-guide/page";
import SafetyPage from "@/pages/article/is-sugargoo-legit-safety/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/sugargoo-spreadsheet-ultimate-guide",
    element: <UltimateGuide />,
  },
  {
    path: "/article/sugargoo-spreadsheet-shoes-guide",
    element: <ShoesGuide />,
  },
  {
    path: "/article/sugargoo-spreadsheet-clothing-guide",
    element: <ClothingGuide />,
  },
  {
    path: "/article/sugargoo-spreadsheet-best-finds",
    element: <BestFinds />,
  },
  {
    path: "/article/sugargoo-spreadsheet-beginner-tutorial",
    element: <BeginnerTutorial />,
  },
  {
    path: "/article/sugargoo-review-2026",
    element: <Review2026 />,
  },
  {
    path: "/article/sugargoo-shipping-cost-guide",
    element: <ShippingCost />,
  },
  {
    path: "/article/sugargoo-coupon-discount-guide",
    element: <CouponGuide />,
  },
  {
    path: "/article/sugargoo-warehouse-guide",
    element: <WarehouseGuide />,
  },
  {
    path: "/article/is-sugargoo-legit-safety",
    element: <SafetyPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;